import React, { createContext, useState, useContext } from 'react';
import { loadFromStorage } from '@/lib/storage';
import { formatDateKey, isValidDate } from '@/lib/dateUtils';
import { useUser } from '@/context/UserContext';

const DateContext = createContext();

export const useDate = () => useContext(DateContext);

export const DateProvider = ({ children }) => {
  const { selectedUser } = useUser(); 
  const [currentDate, setCurrentDate] = useState(() => {
    const storedDateString = loadFromStorage("CURRENT_DATE", null, selectedUser);
    if (storedDateString) {
      const date = new Date(storedDateString);
      if (isValidDate(date)) {
        return date;
      }
    }
    return new Date();
  });
  const [selectedDayKey, setSelectedDayKey] = useState(() => formatDateKey(currentDate));

  return (
    <DateContext.Provider value={{ currentDate, setCurrentDate, selectedDayKey, setSelectedDayKey }}>
      {children}
    </DateContext.Provider>
  );
};